import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { InfoTooltip } from '../../types/tooltip-types';

@Component({
    selector: 'information-tooltip',
    templateUrl: './information-tooltip.component.html',
    styleUrls: ['./information-tooltip.component.scss'],
    standalone: false
})
export class InformationTooltipComponent implements OnInit, OnChanges {
  @Input() toolTipType: InfoTooltip | undefined;
  @Input() isStaticTooltip: boolean = false;
  tooltipText: string = '';

  ngOnInit() {
    this.tooltipText = this.getToolTipText();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['toolTipType'] || changes['isStaticTooltip']) {
      this.tooltipText = this.getToolTipText();
    }
  }

  // Can leverage programatic styles if needed for different tooltip types.
  getToolTipText() {
    switch(this.toolTipType) {
      case InfoTooltip.EnterpriseTerms:
        return "Use this toggle to view divisional and enterprise‑level terms that are relevant to you.";
      case InfoTooltip.LaborProductivityTerms:
        return "Switch to divisional terms to see the impact categories under labor productivity";
      default:
        return '';
    }
  }
}
